var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"scroll-to-target scroll-to-top",attrs:{"href":"#","data-target":"html"}},[_c('i',{staticClass:"fa fa-angle-up"})])
}]

export { render, staticRenderFns }